export default __webpack_public_path__ + "toystory.a41f7c6d.svg";